import { render, staticRenderFns } from "./star_rating.vue?vue&type=template&id=c6312ebe&scoped=true&"
import script from "./star_rating.vue?vue&type=script&lang=js&"
export * from "./star_rating.vue?vue&type=script&lang=js&"
import style0 from "./star_rating.vue?vue&type=style&index=0&id=c6312ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6312ebe",
  null
  
)

export default component.exports